import { MigrationInterface, QueryRunner } from 'typeorm'

import { logger } from '@things-factory/env'
import { Domain, getRepository } from '@things-factory/shell'

import { Group } from '../service/group/group.js'

const SEED_GROUP = [
  {
    name: 'DASHBOARD',
    description: 'Dashboard'
  }
]

export class SeedGroup1556862253000 implements MigrationInterface {
  public async up(queryRunner: QueryRunner): Promise<any> {
    const repository = getRepository(Group)
    const domainRepository = getRepository(Domain)
    const domain = await domainRepository.findOneBy({ name: 'SYSTEM' })

    try {
      return await Promise.all(
        SEED_GROUP.map(async group => {
          await repository.save({
            ...group,
            domain
          })
        })
      )
    } catch (e) {
      logger.error(e)
    }
  }

  public async down(queryRunner: QueryRunner): Promise<any> {
    const repository = getRepository(Group)
    const domainRepository = getRepository(Domain)
    const domain = await domainRepository.findOneBy({ name: 'SYSTEM' })

    SEED_GROUP.reverse().forEach(async group => {
      let record = await repository.findOne({
        where: {
          domain: { id: domain.id },
          name: group.name
        }
      })

      await repository.remove(record)
    })
  }
}
